import type { SupportedLanguage } from 'featureSliced/shared/utils/localization/i18n'
import { normalizeStoredAllowedLanguages } from 'featureSliced/shared/utils/localization/setupLanguages'

export const initialState: ICommon = {
  selectedLanguage: 'de',
  allowedLanguages: normalizeStoredAllowedLanguages(),
  isTopScrolled: true,
  allergens: [],
  tableData: {
    id: 0,
    caption: '',
    objectTag: '',
    projectId: 0,
    roomCaption: '',
    roomId: 0,
  },
}

export interface ICommon {
  selectedLanguage: SupportedLanguage
  allowedLanguages: SupportedLanguage[]
  isTopScrolled: boolean
  allergens: IAllergen[]
  tableData: ITable
}

export interface IAllergen {
  id: number
  name: string
}

// deprecated
// export interface ITableData {
//   id: number
//   caption: string
//   objectTag: string
// }

export interface IFetchAllergens {
  guid: string
  registerId: string | number
}

export interface IFetchTableData {
  table?: string | number
  caption?: string | number
}

export interface ITable {
  caption: string
  id: number
  objectTag: any
  projectId: number
  roomCaption: string
  roomId: number
}
